export default __webpack_public_path__ + "static/media/a017-h.75f8f499.svg";